import { LoggerService as logger } from "vue-components-library";

import router from "@/App/router";
import { AuthorizationService } from "@/Login/services";
import { SsoService } from "@/Login/services/Sso.Service";
import { ssoLoginFailed } from "@/Login/store/Messages";

const LOG_TAG = "[SSO STORE]";
const maxServerResponseLength = 200;

const state = {
  isHandlingToken: false,
  errorMessage: "",
};

const getters = {
  isSsoAvailable: () => SsoService.isConfigured(),
};

const actions = {
  startSsoLogin() {
    window.location.href = SsoService.createSsoUrl();
  },

  async handleSsoToken({ commit, dispatch }: any, { token, signOutUrl }: { token?: string; signOutUrl?: string }) {
    if (!token) {
      await router.push("/");

      return;
    }

    commit("SET_HANDLING_TOKEN", true);
    commit("SET_ERROR", "");

    try {
      const loginResponse = await AuthorizationService.resolveUserByToken(SsoService.buildAuthorizationToken(token));

      await dispatch("Login/setupUser", loginResponse, { root: true });

      SsoService.rememberSignOutUrl(signOutUrl);

      await router.push({ name: "team-selection" });
    } catch (error) {
      logger.error(`${LOG_TAG} Failed to complete SSO login`, { error });
      SsoService.forgetSignOutUrl();
      const detail = String(error).slice(0, maxServerResponseLength);

      commit("SET_ERROR", `${ssoLoginFailed}\nServer response: ${detail}`);
    } finally {
      commit("SET_HANDLING_TOKEN", false);
    }
  },
};

const mutations = {
  SET_HANDLING_TOKEN(state: any, isHandlingToken: boolean) {
    state.isHandlingToken = isHandlingToken;
  },
  SET_ERROR(state: any, message: string) {
    state.errorMessage = message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
